export default "__VITE_ASSET__D7O6L6x___"